import gql from 'graphql-tag';

export const schema = gql`
  mutation RemovePropertyListingPublicationAttribute(
    $publicationId: String!
    $attributeId: String!
  ) {
    removePropertyListingPublicationAttribute(
      publicationId: $publicationId
      attributeId: $attributeId
    ) {
      __typename
      ... on RemovePropertyListingPublicationAttributeSuccess {
        publication {
          id
        }
      }
      ... on RemovePropertyListingPublicationAttributeFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }
    }
  }
`;
